import { z } from "zod";

export const eventRegistrationSchema = z
	.object({
		event_id: z.string().min(1, "Please select a programme/event"),
		sub_event_id: z.string().min(1, "Please select a registration type"),
		workshop_id: z.string().optional().or(z.literal("")),
		fee_category_id: z.string().min(1, "Please select your category"),
		title: z.string().optional().or(z.literal("")),
		first_name: z.string().min(1, "First name is required"),
		last_name: z.string().min(1, "Last name is required"),
		phone: z.string().min(1, "Telephone number is required"),
		email: z.string().email("Enter a valid email address"),
		confirm_email: z.string().email("Enter a valid email address"),
		faculty_id: z.string().optional().or(z.literal("")),
		mdc_number: z.string().optional().or(z.literal("")),
		category_other: z.string().optional().or(z.literal("")),
		senior_waiver_applied: z.boolean(),
		payment_method: z.enum(["card", "momo"]),
		momo_mobile_number: z.string().optional().or(z.literal("")),
		momo_mobile_network: z.enum(["MTN", "VODAFONE", "AIRTELTIGO"]).optional().or(z.literal("")),
	})
	.refine((data) => data.email === data.confirm_email, {
		message: "Email addresses do not match",
		path: ["confirm_email"],
	})
	.refine((data) => data.payment_method !== "momo" || !!data.momo_mobile_number, {
		message: "Mobile number is required for Mobile Money payment",
		path: ["momo_mobile_number"],
	})
	.refine((data) => data.payment_method !== "momo" || !!data.momo_mobile_network, {
		message: "Mobile network is required for Mobile Money payment",
		path: ["momo_mobile_network"],
	});

export type EventRegistrationFormData = z.infer<typeof eventRegistrationSchema>;
